import { QueryParamValue } from '../../types/utility'

/**
 * Not intended for boolean false param value, since we always return a string.
 * A false param value should return null, but that would ruin the convenience
 * of this convenience function.
 */
export function singleQueryParamValue(queryParamValue: NonNullable<QueryParamValue>): string
export function singleQueryParamValue(queryParamValue: QueryParamValue): string | undefined
export function singleQueryParamValue<T = undefined>(
  queryParamValue: QueryParamValue,
  defaultValue: T
): T | string
export function singleQueryParamValue<T = undefined>(
  queryParamValue: QueryParamValue,
  defaultValue?: T
): T | string | undefined {
  if (typeof queryParamValue === 'boolean') return ''
  return (Array.isArray(queryParamValue) ? queryParamValue[0] : queryParamValue) ?? defaultValue
}
